const DeviceReplacement = {
  DeviceReplacement: {
    toDoText: 'Prima di avviare la sostituzione, accertarsi che siano stati eseguiti i seguenti passaggi',
    toDoListItems: [
      'Scollegare il dispositivo da sostituire',
      'Collegare il dispositivo sostitutivo',
      'Configurare il dispositivo sostitutivo'
    ],
    install_replacement: {
      submitFirstStep: 'Recupero dei dettagli',
      hems_device_api_fault:
        'Se si sta cercando di sostituire un carico di terze parti attivo ma non si riesce a visualizzarlo nel menu a discesa, ricaricare la pagina.',
      labelOldDevice: 'Dettagli del vecchio dispositivo',
      labelNewDevice: 'Dettagli del nuovo dispositivo',
      submitSecondStep: 'Confermare la sostituzione',
      warningText: `Se i dati del dispositivo non sono corretti o per qualsiasi altro problema, <a style="color:#F37321;"  href="javascript: window.parent.location.reload();" >fare clic qui</a> per tornare indietro.`,
      DeviceTypes: {
        EVSE: 'IQ ER EVSE',
        ENERGY_METER: 'Contatore di energia',
        SG_READY_GATEWAY: 'Relè SG Ready',
        MICROINVERTER: 'Microinverter',
        AC_BATTERY: 'Batteria CA',
        selectDeviceType: 'selezionare il tipo di dispositivo'
      }
    },
    replace_gateway: {
      submitFirstStep: 'Sostituzione del IQ Energy Router',
      hems_device_api_fault:
        'Se si sta cercando di sostituire un IQ Energy Router attivo ma non si riesce a visualizzarlo nel menu a tendina, ricaricare la pagina.',
      submitSecondStep: 'Sostituzione del IQ Energy Router',
      labelOldDevice: 'Dettagli vecchio IQ ER',
      labelNewDevice: 'Dettagli nuovo IQ ER',
      warningText: `Se i dati del dispositivo non sono corretti o per qualsiasi altro problema, <a style="color:#F37321;"  href="javascript: window.parent.location.reload();" >fare clic qui</a> per tornare indietro.`,
      DeviceTypes: {
        IQ_ENERGY_ROUTER: 'IQ Energy Router',
        IQ_GATEWAY: 'IQ Gateway',
        selectDeviceType: 'Selezionare il tipo di gateway'
      }
    },
    alert: {
      footerMessage: "Se il problema persiste, contattare l'assistenza clienti Enphase.",
      requestTimedOut: {
        mainMessage: 'La richiesta è scaduta',
        subMessage: 'Riprovare più tardi'
      },
      multipleDeviceFound: {
        mainMessage: 'Sostituzione non supportata',
        subMessageIqErEvse:
          'Nel sito sono stati rilevati più di 1 EVSE IQ ER. La sostituzione non è supportata per questo tipo di configurazione del sito.',
        subMessageEnergyMeter:
          'Nel sito sono stati rilevati più di 1 Energy Meter. La sostituzione non è supportata per questo tipo di configurazione del sito.',
        subMessageSgReadyRelay:
          'Nel sito sono stati rilevati più di 1 SG Ready Relay. La sostituzione non può essere supportata per questo tipo di configurazione del sito.'
      },
      iqErOffline: {
        mainMessage: 'IQ ER non segnala',
        subMessage: "Assicurarsi che l'IQ Energy Router sia alimentato e connesso a Internet."
      },
      deviceNotOffline: {
        mainMessage: 'Vecchio dispositivo connesso',
        subMessage:
          'Rilevata la connessione di un vecchio dispositivo. Scollegare il vecchio dispositivo e avviare nuovamente la sostituzione.'
      },
      deviceReplacementInProgress: {
        mainMessage: 'La sostituzione del dispositivo è già in corso per questo tipo di dispositivo'
      },
      deviceNotFound: {
        mainMessage: 'Nuovo dispositivo non rilevato',
        subMessage:
          'I dettagli del nuovo dispositivo non sono stati trovati. Assicurarsi che il nuovo dispositivo sia connesso a Internet e configurato.'
      },
      invalidRmaStatusId: {
        mainMessage: 'Sostituzione fallita',
        subMessage: 'Sostituzione fallita a causa di uno stato di sostituzione sconosciuto'
      },
      activationDuplicateSite: {
        mainMessage: 'Sostituzione fallita',
        subMessage: 'Sostituzione fallita perché il nuovo IQ Energy Router è già attivo'
      },
      authPending: {
        mainMessage: 'Sostituzione fallita',
        subMessage: "Sostituzione fallita perché l'IQ Energy Router esistente non è ancora autorizzato"
      },
      invalidIqEnergyRouter: {
        mainMessage: 'Sostituzione fallita',
        subMessage: "Sostituzione fallita perché il numero di serie dell'IQ Energy Router inserito non è valido"
      },
      hemsDevicesNotDiscovered: {
        mainMessage: 'Sostituzione fallita',
        subMessage:
          'Sostituzione fallita perché i dispositivi di terze parti HEMS rilevati in precedenza non sono stati trovati'
      },
      iqGatewayNotDiscovered: {
        mainMessage: 'Sostituzione fallita',
        subMessage: 'Sostituzione fallita perché il Gateway IQ non è ancora stato rilevato dal IQ Energy Router'
      },
      authInitFailed: {
        mainMessage: 'Sostituzione fallita',
        subMessage: "Sostituzione non riuscita perché l'autorizzazione del dispositivo non è stata avviata"
      },
      invalidDeviceType: {
        mainMessage: 'Tipo di dispositivo non valido per la sostituzione',
        subMessage:
          'Assicurarsi che sia stato selezionato il tipo di dispositivo corretto prima di inviare la richiesta.'
      },
      invalidSite: {
        mainMessage: 'Tipo di sito non supportato',
        subMessage: 'La configurazione del sito non supporta questa sostituzione'
      },
      invalidDevice: {
        mainMessage: 'Il vecchio ID dispositivo non sembra valido',
        subMessage: 'La sostituzione non è supportata per questo dispositivo'
      },
      invalidDeviceUid: {
        mainMessage: 'Gli ID del vecchio e del nuovo dispositivo sono uguali',
        subMessage: 'La sostituzione non è supportata per questo dispositivo'
      },
      deviceReplacementCompleted: {
        mainMessage: 'Sostituzione completata',
        subMessage:
          "Se la convalida funzionale del nuovo dispositivo è in attesa, completarla utilizzando l'Enphase Installer Application (ITK)."
      },
      itkSuccessMessage: {
        iqErEvse: 'EV Charger è stato sostituito con successo',
        energyMeter: 'Energy meter è stato sostituito con successo',
        sgReadyRelay: 'SG Ready Relay è stato sostituito con successo',
        iqEnergyRouter: "L'IQ Energy Router è stato sostituito con successo"
      },
      fetchingDeviceDetailsLoader: { subMessage: 'Recupero dei dettagli del dispositivo' },
      initiatingReplacementLoader: { subMessage: 'Avvio della sostituzione' },
      replacementInprogressLoader: { subMessage: 'Sostituzione in corso' }
    }
  }
};

export default DeviceReplacement;
